import apiFetch from "../../../../shared/services/apiClient";

/**
 * Inicia el envío de correos en background.
 * @param {number[]} facturaIds - array de id_factura
 * @param {'es'|'en'} idioma    - idioma del PDF y correo (default 'es')
 * @returns {{ task_id: string }}  — HTTP 202
 */
export async function sendInvoiceEmail(facturaIds, idioma = 'es') {
  const res = await apiFetch("/api/finance/factura/enviar-email/", {
    method: "POST",
    body: JSON.stringify({ factura_ids: facturaIds, idioma }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error ?? "Error al enviar el correo.");
  }

  return res.json(); // { task_id }
}

/**
 * Consulta el estado de un envío en background.
 * @param {string} taskId
 * @returns {{ done: boolean, enviados?, errores?, total_enviados?, total_errores? }}
 */
export async function getEmailStatus(taskId) {
  const res = await apiFetch(
    `/api/finance/factura/email-status/?task_id=${encodeURIComponent(taskId)}`
  );
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error ?? "Error consultando estado del envío.");
  }
  return res.json();
}
